import {Component} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';
import {MatButtonModule} from '@angular/material/button';
import domtoimage from 'dom-to-image';
import JSZip from 'jszip';
import {BaseStateReportWidget} from '../base-state-report-widget';

@Component({
  selector: 'tgrid-cost-outage-counties-calculated-widget',
  imports: [
    MatCardModule,
    VulcanIconComponent,
    MatButtonModule,
  ],
  templateUrl: './cost-outage-counties-calculated-widget.component.html',
  styleUrl: './cost-outage-counties-calculated-widget.component.scss',
})
export class CostOutageCountiesCalculatedWidgetComponent extends BaseStateReportWidget {

  protected async export(): Promise<void> {
    const container = this.exportContent()?.nativeElement;
    if (!container) return;


    const content = container.innerText;

    // --- PNG ---
    const dataUrl = await domtoimage.toPng(container, { bgcolor: '#ffffff' });
    const base64 = dataUrl.split(',')[1];

    // --- Zip ---
    const zip = new JSZip();
    zip.file('cost_outage_calculated_description.txt', content);
    zip.file('cost_outage_calculated_description.png', base64, { base64: true });

    const zipBlob = await zip.generateAsync({ type: 'blob' });

    const pngAnchor = document.createElement('a');
    pngAnchor.href = URL.createObjectURL(zipBlob);
    pngAnchor.download = 'cost_outage_counties_calculated_description.zip';
    pngAnchor.click();
  }

}
